module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiCn.a835cdf.woff";